// Parse cloud does not supports setTimeout
// We do not store a setTimeout reference in the client everytime
// We only fallback to a fake setTimeout when not available
// setTimeout cannot be override globally sadly
module.exports = function exitPromise(fn, _setTimeout) {
  _setTimeout(fn, 0);
};



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch/src/exitPromise.js
// module id = 20
// module chunks = 0